import {
  IDeleteByIdRequest,
  IDeleteUserResponse,
  IGetAllUsersResponse,
  IGetByIdRequest,
  IGetUserByIdResponse,
  IPaginationRequest,
} from "model";
import {
  ICreateRoleRequest,
  ICreateRoleResponse,
  IUpdateRoleRequest,
  IUpdateRoleResponse,
} from "model/Role";
import { PREFIX } from "utils/Const";
import { BaseApiService } from "./BaseApiService";
const prefix = PREFIX.role;
const getUrl = (url: string) => {
  return `${prefix}/${url}`;
};

const URL_GET_ALL_ROLES = getUrl("get-all-roles");
const URL_GET_ROLE_BY_ID = getUrl("get-role-by-id");
const URL_CREATE_ROLE = getUrl("create-role");
const URL_UPDATE_ROLE = getUrl("update-role");
const URL_DELETE_ROLE = getUrl("delete-role");

class RoleApiService extends BaseApiService {
  public getAllRoles = (request: IPaginationRequest) =>
    this.get<IGetAllUsersResponse>(URL_GET_ALL_ROLES, {
      params: request,
    });
  public getRoleById = (request: IGetByIdRequest) =>
    this.get<IGetUserByIdResponse>(URL_GET_ROLE_BY_ID, {
      params: request,
    });
  public createRole = (request: ICreateRoleRequest) =>
    this.post<ICreateRoleRequest, ICreateRoleResponse>(
      URL_CREATE_ROLE,
      request
    );
  public updateRole = (request: IUpdateRoleRequest) =>
    this.put<IUpdateRoleRequest, IUpdateRoleResponse>(URL_UPDATE_ROLE, request);
  public deleteRole = (request: IDeleteByIdRequest) =>
    this.delete<IDeleteUserResponse>(URL_DELETE_ROLE, {
      params: request,
    });
}

export default new RoleApiService();
